const apiUrl ="https://server.vedicarchitects.in/"
// const apiUrl = "http://localhost:8000/"

export default apiUrl